import { StaticContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { TextAlignment } from '../../types/text.types.js'

export type TopSectionData = {
  images: FileEntryBM[]
  overlayColor: string
  overlayStrength: number
  headerText: string
  headerHighlight?: string
  paragraphText: string
  ctaLink: string
  ctaText: string
  ctaColor?: 'primary' | 'accent'
  marginBottom: string
  minHeight: string
  alignment?: TextAlignment
}

export const topsection: StaticContentType<TopSectionData> = {
  name: 'topsection',
  viewName: 'Toppsektion',
  featureKey: 'topSection',
  uuid: '',
  default: true,
  index: 0,
  data: {
    images: [],
    overlayColor: 'black',
    overlayStrength: 0.5,
    headerText: 'Min rubrik',
    paragraphText: 'Min underrubrik',
    ctaLink: '',
    ctaText: '',
    marginBottom: '2rem',
    minHeight: '40vh',
  },
}
